import { ButtonRoot } from '@/components/common/Button'
import { LinkOutbound, LinkRoute } from '@/components/common/Link'
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type Dict } from '@/defs/misc'
import { type QuickLinkType } from '@/defs/nav'
import { trackEvent } from '@/utils/analyticsUtil'
import { cn } from '@/utils/commonUtil'

import { TopBarQuickLinkRandom } from './TopBarQuickLinkRandom/TopBarQuickLinkRandom'

type Props = {
  item: QuickLinkType
  styles: Dict<string>
}

export const TopBarQuickLink = ({ item, styles }: Props) => {
  if (item.variant === 'divider') return <li className={cn(styles.item, styles.divider)}>&nbsp;</li>

  if (item.variant === 'theme-switcher') {
    return (
      <li className={cn(styles.item, styles.themeSwitcher)}>
        <ThemeSwitcher />
      </li>
    )
  }

  if (item.variant === 'random') {
    return (
      <li className={styles.item}>
        <TopBarQuickLinkRandom item={item} styles={styles} />
      </li>
    )
  }

  const { icon, label, superscript, variant } = item

  const hasSubmenu = item.variant === 'submenu'

  const onClick = (href: string) => {
    trackEvent({ action: 'nav_click', category: 'topbar', label: href })
  }

  const element = (() => {
    if (hasSubmenu) {
      return (
        <>
          <ButtonRoot className={styles.button} type='button'>
            <IconWithLabel iconAfter='caret' iconAfterSize='xs' iconBefore={icon}>
              {label}
            </IconWithLabel>
            {superscript && <sup>{superscript}</sup>}
          </ButtonRoot>
          <ul className={styles.submenu}>
            {item.submenu.map((itemInner, i) => (
              <TopBarQuickLink item={itemInner} key={i} styles={styles} />
            ))}
          </ul>
        </>
      )
    }

    const Element = item.newTab ? LinkOutbound : LinkRoute

    return (
      <Element
        className={cn(styles.button, { styles, variant })}
        href={item.href}
        onClick={() => onClick(item.href)}
        {...(item.newTab && { utm: { medium: 'navbar' } })}
      >
        <IconWithLabel iconBefore={icon}>{label}</IconWithLabel>
        {superscript && <sup>{superscript}</sup>}
      </Element>
    )
  })()

  return <li className={cn(styles.item, { hasSubmenu, styles })}>{element}</li>
}
